import * as msg from '../../helpers/console'
import handleViewForms from '../../components/handleViewForms'
import collapses from '../../components/collapses'

const init = () => {
  msg.success('ViewScholarshipsController', 'Ready!')
  new handleViewForms().init();
  new collapses().init();
}

export default init
